import { render, staticRenderFns } from "./resource-state.vue?vue&type=template&id=266a6746&scoped=true"
import script from "./resource-state.vue?vue&type=script&lang=js"
export * from "./resource-state.vue?vue&type=script&lang=js"
import style0 from "./resource-state.vue?vue&type=style&index=0&id=266a6746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266a6746",
  null
  
)

export default component.exports